module.exports = __webpack_public_path__ + "img/product_27.e23602b.jpg";